import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material';

import builderPathInit from '../../util/builder-path-init';
import MagicSvgWidget from '../../components/magic-svg/magic-svg';
import magicSvgBuilderConfig from '../../components/magic-svg/magic-svg.builder.config';
import magicSvgImageCardBuilderConfig
  from '../../components/magic-svg/magic-svg-image.card.builder.config';
import MagicSvgImageCard from '../../components/magic-svg/magic-svg-image-card';
import magicSvgPageWrapper from '../../components/magic-svg/pages/magic-svg-page.builder';
import magicSvgPageWrapperBuilderConfig
  from '../../components/magic-svg/pages/magic-svg-page.builder.config';
import muiTheme from '../../components/magic-svg/magic-svg.styles';
import { fetchSpecificImage } from '../../api/magic-svg';
import
MagicSvgProvider,
{ MagicSvgImageShape }
  from '../../context/MagicSvgContext/MagicSvgProvider';

const { BuilderPage, getServerSideProps: internalServerSideProps } = builderPathInit({
  model: 'svg-page',
  pathPrefix: 'svg',
  components: [
    {
      config: magicSvgBuilderConfig,
      component: MagicSvgWidget,
    },
    {
      config: magicSvgImageCardBuilderConfig,
      component: MagicSvgImageCard,
    },
    {
      config: magicSvgPageWrapperBuilderConfig,
      component: magicSvgPageWrapper,
    },
  ],
});

function MagicSvgBuilderPageComponent(props) {
  const { content: { data: { magicSvgInitialImage = {} } } } = props;

  return (
    <MagicSvgProvider initialImage={magicSvgInitialImage}>
      <ThemeProvider theme={muiTheme}>
        <BuilderPage {...props} />
      </ThemeProvider>
    </MagicSvgProvider>
  );
};

const contentShape = PropTypes.shape({
  data: PropTypes.shape({
    magicSvgInitialImage: MagicSvgImageShape,
  }),
});

MagicSvgBuilderPageComponent.propTypes = {
  content: contentShape.isRequired,
};

export default MagicSvgBuilderPageComponent;

export async function getServerSideProps(context) {
  const props = await internalServerSideProps(context);
  // If the page isn't found (dev mode), it crashes trying to
  // access content
  if (props?.notFound) return props;

  const { props: { content } } = props;
  const { query } = context;

  const { result } = query;
  if (result && content) {
    // override the image with one loaded from the result
    // id passed in the query string
    const image = await fetchSpecificImage(result);
    content.data.magicSvgInitialImage = image;
    content.data.image = {
      imageFile: image.previewUrl || image.imageUrl,
      width: 1200,
      height: 630,
    };
  }
  return props;
}
